//#region src/storage/StorageAdapter.ts
var e = {
	getItem(e) {
		return typeof localStorage > "u" ? null : localStorage.getItem(e);
	},
	setItem(e, t) {
		typeof localStorage > "u" || localStorage.setItem(e, t);
	},
	removeItem(e) {
		typeof localStorage > "u" || localStorage.removeItem(e);
	}
};
//#endregion
export { e as webLocalStorageAdapter };
